
import { PropType } from 'vue'

type User = {
    type: string
    id: string
    name: string
    primaryEmail: string
    mobileNumber: Maybe<string>
    phoneNumber: string
    jobTitle: string
    avatarFileId: string
}

export default {
    name: 'UserAvatar',
    props: {
        user: {
            type: Object as PropType<User>,
            required: true,
        },
    },
    computed: {
        initials() {
            if (!this.user.name) return ''
            const [first, ...rest] = this.user.name.split(' ')
            return `${first[0]}${rest?.pop()?.[0] || ''}`
        },
    },
}
